import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// import QuotationModal from './quotationFrom';
import { Box } from '@mui/material';
import { getQuotationById, updateQuotation } from '../../../services/api/quotation';
import QuotationForm from './quotationFrom';
import { getAllEvent } from '../../../services/api/Event';

const EditQuotationPage = () => {
	const { id } = useParams();
	console.log(id, 'ddd');

	const navigate = useNavigate();
	const [quotation, setQuotation] = useState(null);
	const [loading, setLoading] = useState(false);
	const [eventTypes, setEventTypes] = useState([]);
	// console.log(quotation, 'defaultMenuId');
	useEffect(() => {
		const fetchQuotation = async () => {
			try {
				setLoading(true);
				const data = await getQuotationById(id);

				setQuotation(
					// Array.isArray(data.data.quotation.defaultMenuId) &&
					data?.data?.quotation?.defaultMenuId
						? data?.data?.quotation
						: data?.data?.quotation
				);
			} catch (error) {
				console.error('Failed to fetch quotation:', error);
			} finally {
				setLoading(false);
			}
		};
		fetchQuotation();
	}, [id]);

	const handleUpdateQuotation = async (updatedQuotation: any) => {
		try {
			setLoading(true);
			await updateQuotation(updatedQuotation, id);
			navigate('/quotation');
		} catch (error) {
			console.error('Failed to update quotation:', error);
		}
	};

	const loadEventTypes = useCallback(async () => {
		try {
			const response = await getAllEvent();
			setEventTypes(response?.data?.eventTypes);
		} catch (error) {
			console.error('Failed to load event types:', error);
		}
	}, []);

	useEffect(() => {
		loadEventTypes();
	}, [loadEventTypes]);

	return (
		<Box sx={{ overflow: 'hidden' }}>
			{/* <h1>Edit Quotation</h1> */}
			<QuotationForm
				initialData={quotation}
				onSubmit={handleUpdateQuotation}
				onClose={() => navigate('/quotation')}
				eventTypes={eventTypes} // Ensure eventTypes is passed
				loader={loading} // Provide a default value for loader
			/>
		</Box>
	);
};

export default EditQuotationPage;
